import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { FormField } from '../../../../../../components/FormFields';
import { Loader } from '../../../../../../components/Loader';
import { VehicleCreateFieldCompany } from '../../../../../Vehicles/pages/create/FieldCompany';
import { initiateNewVehicleValue, setNewVehicleValue } from '../../../../../Vehicles/actions';
import { selectNewVehicle, selectNewVehicleValue } from '../../../../../Vehicles/selectors';
import { selectWork } from '../../../../../Api/selectors';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../../../Vehicles/constants';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { HBox } from '../../../../../../components/Box';
import { Button } from '../../../../../../components/Buttons';
import { initiateNewInvoiceValue, setNewInvoiceValue } from '../../../../actions';
import { selectNewInvoiceValue } from '../../../../selectors';

dayjs.extend(customParseFormat);

const Container = styled.div`
  width: 100%;
  margin-bottom: 24px;
  .formField {
    .label {
      text-transform: capitalize;
      margin-bottom: 6px;
      color: #6c757d;
    }
  }

  .rightDecorationBlock {
    width: 100px;
    display: flex;

    .deleteBtn {
      background-color: #d50046;
    }
  }
`;

const STATE = {
  value: '',
};

/* eslint-disable react/prefer-stateless-function */
class VehicleCreditorFieldComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.initiateValue();
  }

  addNewCompany() {
    this.props.showNewCompanyModal();
  }

  wrap(children) {
    switch (this.props.type) {
      default:
        return <FormField label={this.formFieldLabel()}>{children}</FormField>;
    }
  }

  formFieldLabel() {
    return this.lbl(`vehicle.property.${this.props.type}`);
  }

  reset() {
    this.setState({ ...STATE });
  }

  render() {
    if (this.props.work) return <Loader small />;

    return <Container>{this.wrap(this.renderField())}</Container>;
  }

  renderField() {
    if (this.props.value === undefined) return null;

    switch (this.props.type) {
      case 'creditor_company':
        return (
          <HBox left vCenter style={{ gap: '10px' }}>
            {!this.props.tradeInVehicle ? (
              <>
                <VehicleCreateFieldCompany
                  order={this.props.order}
                  title={this.props.type}
                  key={this.props.type}
                  type={this.props.type}
                  onChange={value => this.props.setValue(value)}
                />
                <Button small onClick={this.addNewCompany.bind(this)}>
                  {this.lbl('new_customer')}
                </Button>
              </>
            ) : (
              <>
                <VehicleCreateFieldCompany
                  tradeInVehicle
                  order={this.props.order}
                  title={this.props.type}
                  key={this.props.type}
                  type={this.props.type}
                  onChange={value => this.props.setValue(value)}
                />
              </>
            )}
          </HBox>
        );
    }
  }
}

VehicleCreditorFieldComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_VEHICLE_PROPERTY_UPDATE),
    value: ownProps.invoicePage ? selectNewInvoiceValue(ownProps.type) : selectNewVehicleValue(ownProps.type),
    values: selectNewVehicle(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      ownProps.invoicePage ? dispatch(setNewInvoiceValue(name, value)) : dispatch(setNewVehicleValue(name, value));
    },
    initiateValue() {
      ownProps.invoicePage
        ? dispatch(initiateNewInvoiceValue(ownProps.type))
        : dispatch(initiateNewVehicleValue(ownProps.type));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleCreditorField = compose(withConnect, withRouter)(VehicleCreditorFieldComp);
